interface Props {
  paragraphs: string[];
}

/** Small "i" icon that reveals a detailed panel description on hover/focus */
export function InfoTip({ paragraphs }: Props) {
  return (
    <span className="info-tip">
      <button type="button" className="info-tip-btn" aria-label="Panel description">
        i
      </button>
      <div className="info-tip-pop" role="tooltip">
        {paragraphs.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>
    </span>
  );
}
